import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const bannerService = {
  getAllEvents,
  addBanner,
  getEvent,
  deleteEvent
};

function getAllEvents(params) {
  return apiCall("GET", apiUrls.banners.base, null, params);
}

function addBanner(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.banners.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getEvent(id) {
  return apiCall("GET", `${apiUrls.banners.base}/${id}`);
}

function deleteEvent(id) {
  return apiCall("DELETE", `${apiUrls.banners.base}/${id}`);
}
